module.exports = __webpack_public_path__ + "static/media/categories-logo-google-analytics.18124406.svg";